var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeBlackFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_135",
    "data-name": "Rect\\xE1ngulo 135",
    width: 24.184,
    height: 15.316,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_867",
    "data-name": "Grupo 867",
    transform: "translate(-1030 -2491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_567",
    "data-name": "Grupo 567",
    transform: "translate(-507 2056)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_37",
    "data-name": "Elipse 37",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(1537 435)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_673",
    "data-name": "Grupo 673",
    transform: "translate(1037.408 2502.842)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_714",
    "data-name": "Trazado 714",
    d: "M9.76,6.847a2.6,2.6,0,0,0,2.289-2.854C12.049,1.31,10.176,0,7.8,0H0V15H7.8s4.764.15,4.764-4.427c0,0,.208-3.724-2.809-3.724M3.439,2.666H7.8s1.061,0,1.061,1.56S8.241,6.013,7.534,6.013h-4.1ZM7.6,12.333H3.439V8.325H7.8s1.581-.021,1.581,2.06c0,1.735-1.157,1.931-1.782,1.949",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_715",
    "data-name": "Trazado 715",
    d: "M162.23,45.384c-5.768,0-5.762,5.762-5.762,5.762a5.321,5.321,0,0,0,5.763,5.733s5.132.293,5.132-3.988h-2.639s.088,1.613-2.4,1.613a2.44,2.44,0,0,1-2.64-2.61h7.772s.85-6.511-5.22-6.511m2.346,4.509h-4.927a2.682,2.682,0,0,1,2.639-2.312,2.233,2.233,0,0,1,2.287,2.312",
    transform: "translate(-143.307 -41.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_134",
    "data-name": "Rect\\xE1ngulo 134",
    width: 6.188,
    height: 1.847,
    transform: "translate(15.696 0.883)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeBlackFooter);
export default __webpack_public_path__ + "static/media/BeBlackFooter.332bc37039aee18ee57859acb06185e7.svg";
export { ForwardRef as ReactComponent };